import TagManager, { TagManagerArgs } from 'react-gtm-module';
import { HpClaimsDebugFlags, logInfo } from '../clientLogging';
import { HpClaimsClientConfiguration } from '../config/configurationTypes';
import { setupGtmEventHandler } from '../tools/gtmEventHandler';

export function configureGtm(config: HpClaimsClientConfiguration): void {
  const { gtmEnabled, gtmId } = config;
  if (!gtmEnabled) {
    return;
  }

  const gtmOptions: TagManagerArgs = { gtmId };

  logInfo(`Configuring GTM with ${JSON.stringify(gtmOptions)}`, HpClaimsDebugFlags.Configuration);
  TagManager.initialize(gtmOptions);

  setupGtmEventHandler();
}

const gtmTags = Object.freeze({
  errorPage: '/Error',
  confirmationPage: '/claim-submitted',
  saveClaimPage: '/before-you-continue/save-claim'
});

export { gtmTags };
